import * as styles from '@/styles/components/FormControl';

type Label = {
  label?: string;
  required?: boolean;
};

const Label = ({ label = '', required = false }: Label) => {
  return (
    <div>
      {label && (
        <div css={styles.label}>
          {label}
          {required && <span css={styles.labelRequired}>必須</span>}
        </div>
      )}
    </div>
  );
};

export default Label;
